import { productUgc } from '../../components/product-ugc'
import { registerElement } from '../../utils/desing-system'

import './product-ugc.scss'

registerElement(productUgc)
